// src/pages/ForgotPassword.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const res = await fetch('https://kepithor.xyz/request_password_reset.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({ email }).toString(),
      });

      if (!res.ok) {
        throw new Error('Unable to process request. Please try again.');
      }

      let data = null;
      try {
        data = await res.json(); // in case your PHP returns JSON
        console.log(data);
      } catch {
        // if it’s plain text or something else, ignore and fallback
      }

      if (data && (data.success || data.status === 'ok')) {
        setSuccess(
          data.message ||
            'If an account with that email exists, a reset link has been sent.'
        );
      } else if (data && (data.error || data.message)) {
        setError(data.error || data.message);
      } else {
        // generic success message to avoid leaking whether the email exists
        setSuccess(
          'If an account with that email exists, a reset link has been sent.'
        );
      }
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (


<>


        <div className="spacer" style={{height: 20}}></div>

        
    <div className="mx-auto max-w-md bg-slate-900/70 border border-slate-800 rounded-2xl p-6 shadow-xl shadow-emerald-500/10">
      <h1 className="text-2xl font-bold mb-2">Forgot password</h1>
      <p className="text-sm text-slate-300 mb-4">
        Enter the email address associated with your account and we&apos;ll send
        you a link to reset your password.
      </p>

      <form onSubmit={handleSubmit} className="grid gap-3">
        <label className="grid gap-1">
          <span className="text-sm text-slate-300">Email</span>
          <input
            className="border border-slate-700 bg-slate-950/60 rounded-xl px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        {error && <div className="text-red-400 text-sm">{error}</div>}
        {success && <div className="text-emerald-400 text-sm">{success}</div>}

        <Button
          disabled={loading}
          className="bg-emerald-500 text-grey hover:bg-emerald-400"
        >
          {loading ? 'Sending reset link…' : 'Send reset link'}
        </Button>

        <div className="text-sm mt-2 text-slate-300">
          Remembered your password?{' '}
          <Link to="/login" className="text-emerald-300 underline">
            Back to sign in
          </Link>
        </div>
      </form>
    </div>

</>


  );
}
